<span class="team-icon" aria-hidden="true"
        [style.backgroundColor]="colors.background"
        [style.color]="colors.text"></span>

